module.exports = __webpack_public_path__ + "static/comingsoon3-399d2cba75baffb3caae056ce000ed45.png";